import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

export class UiRouterTitleService {
  private _title = new BehaviorSubject<string>('');

  constructor( public defaultTitle: string,
               public suffix: string,
               private _token: string ) {
    this._title.next(defaultTitle);
  }

  setTitle( title: string ) {
    this._title.next(title);
  }

  getTitle(): Observable<string> {
    return this._title.asObservable();
  }

  getToken(): string {
    return this._token;
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui.router-title.service.ts